import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from "react";

const SetClientsPageStatusBarContext = createContext<
  ((content: ReactNode) => void) | null
>(null);

const ClientsPageStatusBarContentContext = createContext<ReactNode>(null);

export function ClientsPageStatusBarProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [statusBar, setStatusBar] = useState<ReactNode>(null);

  return (
    <SetClientsPageStatusBarContext.Provider value={setStatusBar}>
      <ClientsPageStatusBarContentContext.Provider value={statusBar}>
        {children}
      </ClientsPageStatusBarContentContext.Provider>
    </SetClientsPageStatusBarContext.Provider>
  );
}

export function useClientsPageStatusBarContent() {
  return useContext(ClientsPageStatusBarContentContext);
}

export function useClientsPageStatusBar(content: ReactNode) {
  const setStatusBar = useContext(SetClientsPageStatusBarContext);

  useEffect(() => {
    if (!setStatusBar) return undefined;

    setStatusBar(content);
    return () => setStatusBar(null);
  }, [setStatusBar, content]);
}
